// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Unit from "common/src/data/Unit.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TbUnitSource from "./TbUnitSource.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as TbTraitUnitsGrid from "./TbTraitUnitsGrid.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Input from "@mui/material/Input";
import Tooltip from "@mui/material/Tooltip";
import Clear from "@mui/icons-material/Clear";
import FormControl from "@mui/material/FormControl";
import Search from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

var tierBgs = [
  "bg-[#bbbbbb33]",
  "bg-[#5bc17333]",
  "bg-[#5abff633]",
  "bg-[#d11ab233]",
  "bg-[#f5bf3833]"
];

function TbUnitSelection(Props) {
  var choiceTab = Props.choiceTab;
  var addUnit = Props.addUnit;
  var setSearch = Props.setSearch;
  var search = Props.search;
  var highlightTrait = Props.highlightTrait;
  var exaltedUnits = Props.exaltedUnits;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  var unitsT = Translation.useT(/* Units */1);
  Translation.useT(/* Traits */2);
  var screen = ScreenAtom.use(undefined);
  var match = React.useState(function () {
        return /* Cost */0;
      });
  var setSorting = match[1];
  var sorting = match[0];
  search.toLowerCase();
  var unitSearchMatches;
  if (search === "") {
    unitSearchMatches = undefined;
  } else {
    var units = Search2.searchUnitsArr(search, set);
    if (exaltedUnits !== undefined) {
      var traits = Search2.searchTraitsArr(search, set);
      unitSearchMatches = traits.includes("TFT11_Exalted") ? Belt_Array.concat(units, exaltedUnits) : units;
    } else {
      unitSearchMatches = units;
    }
  }
  var singleMatch = unitSearchMatches !== undefined && unitSearchMatches.length === 1 ? unitSearchMatches[0] : undefined;
  var extraUnits = React.createElement("div", {
        className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-3 xl:pl-[6px] " + Belt_Array.getExn(tierBgs, 0)
      }, set === 170 ? React.createElement(TbUnitSource.make, {
              searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes("TFT17_PVE_ElderDragon") : true,
              highlight: true,
              unit: "TFT17_PVE_ElderDragon",
              size: 44,
              sizeSm: 47,
              sizeMd: 49,
              onClick: addUnit
            }) : React.createElement("div", undefined), React.createElement(TbUnitSource.make, {
            searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes("TFT_BlueGolem") : true,
            highlight: true,
            unit: "TFT_BlueGolem",
            size: 44,
            sizeSm: 47,
            sizeMd: 49,
            onClick: addUnit
          }), React.createElement(TbUnitSource.make, {
            searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes("TFT_TrainingDummy") : true,
            highlight: true,
            unit: "TFT_TrainingDummy",
            size: 44,
            sizeSm: 47,
            sizeMd: 49,
            onClick: addUnit
          }));
  var tmp;
  var exit = 0;
  switch (sorting) {
    case /* Cost */0 :
    case /* Base */1 :
        exit = 1;
        break;
    case /* Unlock */2 :
        var c6Units = Belt_Array.keep(Sd.allUnits(set), (function (unit) {
                return Sd.unitTier(unit) === 6;
              }));
        tmp = React.createElement(React.Fragment, undefined, Belt_Array.map([
                  /* Uncommon */1,
                  /* Rare */2,
                  /* Epic */3,
                  /* Legendary */4
                ], (function (tier) {
                    return React.createElement(React.Fragment, {
                                children: set !== 160 ? null : React.createElement("div", {
                                        key: String(Unit.toCost(tier)),
                                        className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] pt-[0px] " + Belt_Array.getExn(tierBgs, Unit.toCost(tier) - 1 | 0)
                                      }, Belt_Array.map(Belt_Array.keep(Sd.allUnits2(set), (function (unit) {
                                                  if (Sd.unitTier(unit) === Unit.toCost(tier)) {
                                                    return Sd.isUnlock(unit);
                                                  } else {
                                                    return false;
                                                  }
                                                })), (function (unit) {
                                              return React.createElement(TbUnitSource.make, {
                                                          searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                                          highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                                                  if (t === "TFT11_Exalted") {
                                                                    return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                                                  } else {
                                                                    return Sd.getUnitTraits(unit, set).includes(t);
                                                                  }
                                                                })),
                                                          unit: unit,
                                                          size: 44,
                                                          sizeSm: 47,
                                                          sizeMd: 49,
                                                          onClick: addUnit,
                                                          key: unit
                                                        });
                                            }))),
                                key: String(Unit.toCost(tier))
                              });
                  })), c6Units.length === 0 ? null : React.createElement("div", {
                    className: "flex flex-col xl:flex-row"
                  }, React.createElement("div", {
                        className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, 4)
                      }, Belt_Array.map(c6Units, (function (unit) {
                              return React.createElement(TbUnitSource.make, {
                                          searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                          highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                                  if (t === "TFT11_Exalted") {
                                                    return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                                  } else {
                                                    return Sd.getUnitTraits(unit, set).includes(t);
                                                  }
                                                })),
                                          unit: unit,
                                          size: 44,
                                          sizeSm: 47,
                                          sizeMd: 49,
                                          onClick: addUnit,
                                          key: unit
                                        });
                            })))));
        break;
    case /* Name */3 :
        tmp = React.createElement("div", {
              className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] bg-bg"
            }, Belt_Array.map(Belt_SortArray.stableSortBy(Sd.allUnits(set), (function (u1, u2) {
                        return Caml.caml_string_compare(unitsT(u1), unitsT(u2));
                      })), (function (unit) {
                    return React.createElement(TbUnitSource.make, {
                                searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                        if (t === "TFT11_Exalted") {
                                          return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                        } else {
                                          return Sd.getUnitTraits(unit, set).includes(t);
                                        }
                                      })),
                                unit: unit,
                                size: 44,
                                sizeSm: 47,
                                sizeMd: 49,
                                onClick: addUnit,
                                key: unit
                              });
                  })));
        break;
    case /* Origin */4 :
        tmp = React.createElement(TbTraitUnitsGrid.make, {
              unitSearchMatches: unitSearchMatches,
              addUnit: addUnit,
              allTraits: Sd.allOrigins(set)
            });
        break;
    case /* Class */5 :
        var tmp$1 = {
          unitSearchMatches: unitSearchMatches,
          addUnit: addUnit,
          allTraits: Sd.allClasses(set)
        };
        if (exaltedUnits !== undefined) {
          tmp$1.exaltedUnits = Caml_option.valFromOption(exaltedUnits);
        }
        tmp = React.createElement(TbTraitUnitsGrid.make, tmp$1);
        break;
    
  }
  if (exit === 1) {
    var c6Units$1 = Belt_Array.keep(Sd.allUnits(set), (function (unit) {
            return Sd.unitTier(unit) === 6;
          }));
    tmp = React.createElement(React.Fragment, undefined, Belt_Array.map([
              /* Common */0,
              /* Uncommon */1,
              /* Rare */2,
              /* Epic */3
            ], (function (tier) {
                return React.createElement(React.Fragment, {
                            children: null,
                            key: String(Unit.toCost(tier))
                          }, React.createElement("div", {
                                className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, Unit.toCost(tier) - 1 | 0)
                              }, Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.keep(Sd.allUnits2(set), (function (unit) {
                                              if (Sd.unitTier(unit) === Unit.toCost(tier)) {
                                                return !Sd.isUnlock(unit);
                                              } else {
                                                return false;
                                              }
                                            })), (function (u1, u2) {
                                          return Caml.caml_string_compare(Dict.getExn(Data.units(set), u1).name, Dict.getExn(Data.units(set), u2).name);
                                        })), (function (unit) {
                                      return React.createElement(TbUnitSource.make, {
                                                  searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                                  highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                                          if (t === "TFT11_Exalted") {
                                                            return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                                          } else {
                                                            return Sd.getUnitTraits(unit, set).includes(t);
                                                          }
                                                        })),
                                                  unit: unit,
                                                  size: 44,
                                                  sizeSm: 47,
                                                  sizeMd: 49,
                                                  onClick: addUnit,
                                                  key: unit
                                                });
                                    }))), set !== 160 || Unit.toCost(tier) === 1 || sorting === /* Base */1 ? null : React.createElement("div", {
                                  key: String(Unit.toCost(tier)),
                                  className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[2px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, Unit.toCost(tier) - 1 | 0)
                                }, Belt_Array.map(Belt_Array.keep(Sd.allUnits2(set), (function (unit) {
                                            if (Sd.unitTier(unit) === Unit.toCost(tier)) {
                                              return Sd.isUnlock(unit);
                                            } else {
                                              return false;
                                            }
                                          })), (function (unit) {
                                        return React.createElement(TbUnitSource.make, {
                                                    searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                                    highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                                            if (t === "TFT11_Exalted") {
                                                              return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                                            } else {
                                                              return Sd.getUnitTraits(unit, set).includes(t);
                                                            }
                                                          })),
                                                    unit: unit,
                                                    size: 44,
                                                    sizeSm: 47,
                                                    sizeMd: 49,
                                                    onClick: addUnit,
                                                    key: unit
                                                  });
                                      }))));
              })), React.createElement("div", {
              className: "flex flex-col xl:flex-row"
            }, React.createElement("div", {
                  className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:pr-[4px] xl:grid-cols-[repeat(11,48px)] " + Belt_Array.getExn(tierBgs, 4)
                }, Belt_Array.map(Belt_Array.keep(Sd.allUnits4(set), (function (unit) {
                            if (Sd.unitTier(unit) === 5) {
                              return !Sd.isUnlock(unit);
                            } else {
                              return false;
                            }
                          })), (function (unit) {
                        return React.createElement(TbUnitSource.make, {
                                    searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                    highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                            if (t === "TFT11_Exalted") {
                                              return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                            } else {
                                              return Sd.getUnitTraits(unit, set).includes(t);
                                            }
                                          })),
                                    unit: unit,
                                    size: 44,
                                    sizeSm: 47,
                                    sizeMd: 49,
                                    onClick: addUnit,
                                    key: unit
                                  });
                      }))), screen !== /* Xs */5 ? extraUnits : null), set !== 160 || sorting === /* Base */1 ? null : React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[2px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, 4)
                  }, Belt_Array.map(Belt_Array.keep(Sd.allUnits2(set), (function (unit) {
                              if (Sd.unitTier(unit) === 5 && Sd.unitCost(unit, set) === 5) {
                                return Sd.isUnlock(unit);
                              } else {
                                return false;
                              }
                            })), (function (unit) {
                          return React.createElement(TbUnitSource.make, {
                                      searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                      highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                              if (t === "TFT11_Exalted") {
                                                return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                              } else {
                                                return Sd.getUnitTraits(unit, set).includes(t);
                                              }
                                            })),
                                      unit: unit,
                                      size: 44,
                                      sizeSm: 47,
                                      sizeMd: 49,
                                      onClick: addUnit,
                                      key: unit
                                    });
                        }))), React.createElement("div", {
                    className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[2px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, 4)
                  }, Belt_Array.map(Belt_Array.keep(Sd.allUnits2(set), (function (unit) {
                              if (Sd.unitTier(unit) === 5 && Sd.unitCost(unit, set) === 7) {
                                return Sd.isUnlock(unit);
                              } else {
                                return false;
                              }
                            })), (function (unit) {
                          return React.createElement(TbUnitSource.make, {
                                      searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                      highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                              if (t === "TFT11_Exalted") {
                                                return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                              } else {
                                                return Sd.getUnitTraits(unit, set).includes(t);
                                              }
                                            })),
                                      unit: unit,
                                      size: 44,
                                      sizeSm: 47,
                                      sizeMd: 49,
                                      onClick: addUnit,
                                      key: unit
                                    });
                        })))), screen === /* Xs */5 ? extraUnits : null, c6Units$1.length === 0 ? null : React.createElement("div", {
                className: "flex flex-col xl:flex-row"
              }, React.createElement("div", {
                    className: "grid gap-[6px] sm:gap-[9px] p-[12px] pt-[10px] pb-[8px] grid-cols-[repeat(7,44px)] sm:grid-cols-[repeat(13,47px)] md:grid-cols-[repeat(9,48px)] lg:grid-cols-[repeat(9,48px)] xl:grid-cols-[repeat(14,48px)] " + Belt_Array.getExn(tierBgs, 4)
                  }, Belt_Array.map(c6Units$1, (function (unit) {
                          return React.createElement(TbUnitSource.make, {
                                      searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                      highlight: Belt_Option.mapWithDefault(highlightTrait, true, (function (t) {
                                              if (t === "TFT11_Exalted") {
                                                return Belt_Option.getWithDefault(exaltedUnits, []).includes(unit);
                                              } else {
                                                return Sd.getUnitTraits(unit, set).includes(t);
                                              }
                                            })),
                                      unit: unit,
                                      size: 44,
                                      sizeSm: 47,
                                      sizeMd: 49,
                                      onClick: addUnit,
                                      key: unit
                                    });
                        })))));
  }
  return React.createElement("div", {
              className: (
                choiceTab === "Units" ? "" : "hidden md:block "
              ) + "select-none rounded overflow-clip"
            }, React.createElement("div", {
                  className: "flex justify-between w-full min-w-[220px] items-center lg:pr-2 " + (
                    sorting === /* Cost */0 || sorting === /* Base */1 ? Belt_Array.getExn(tierBgs, 0) : "bg-bg"
                  )
                }, React.createElement("div", {
                      className: "pl-3 pt-2"
                    }, React.createElement(Tooltip, {
                          open: Belt_Option.isSome(singleMatch),
                          arrow: true,
                          title: singleMatch !== undefined ? "Press enter to add " + unitsT(singleMatch) : React.createElement("div", undefined),
                          children: React.createElement("div", {
                                className: "w-[120px] lg:w-[150px] xl:w-[220px]"
                              }, React.createElement(FormControl, {
                                    children: React.createElement(Input, {
                                          onKeyDown: (function (e) {
                                              if (e.which === 13 && singleMatch !== undefined) {
                                                Curry._1(addUnit, singleMatch);
                                                return Curry._1(setSearch, (function (param) {
                                                              return "";
                                                            }));
                                              }
                                              
                                            }),
                                          placeholder: screen >= 2 ? t("Search") : t("Search by name/trait"),
                                          value: search,
                                          onChange: (function (e) {
                                              var v = e.target.value;
                                              return Curry._1(setSearch, (function (param) {
                                                            return v;
                                                          }));
                                            }),
                                          startAdornment: React.createElement("div", {
                                                className: "text-white1"
                                              }, React.createElement(InputAdornment, {
                                                    position: "start",
                                                    children: React.createElement(Search, {
                                                          color: "inherit"
                                                        })
                                                  })),
                                          endAdornment: search !== "" ? React.createElement("div", {
                                                  className: "cursor-pointer text-white2",
                                                  onClick: (function (param) {
                                                      return Curry._1(setSearch, (function (param) {
                                                                    return "";
                                                                  }));
                                                    })
                                                }, React.createElement(InputAdornment, {
                                                      position: "end",
                                                      children: React.createElement(Clear, {
                                                            fontSize: "small",
                                                            color: "inherit"
                                                          })
                                                    })) : null
                                        })
                                  }))
                        })), React.createElement("div", {
                      className: "hidden sm:flex pt-1"
                    }, React.createElement(Tabs, {
                          children: null,
                          value: sorting,
                          onChange: (function (param, sorting) {
                              return Curry._1(setSorting, (function (param) {
                                            return sorting;
                                          }));
                            })
                        }, React.createElement(Tab, {
                              label: t("Cost"),
                              value: /* Cost */0
                            }), set === 160 ? React.createElement(Tab, {
                                label: t("Base"),
                                value: /* Base */1
                              }) : null, set === 160 ? React.createElement(Tab, {
                                label: t("Unlock"),
                                value: /* Unlock */2
                              }) : null, React.createElement(Tab, {
                              label: t("Name"),
                              value: /* Name */3
                            }), React.createElement(Tab, {
                              label: t("Origin"),
                              value: /* Origin */4
                            }), React.createElement(Tab, {
                              label: t("Class"),
                              value: /* Class */5
                            })))), tmp);
}

var make = React.memo(TbUnitSelection);

export {
  tierBgs ,
  make ,
  
}
/* make Not a pure module */
